class HeroSlider {
  constructor(element) {
    this.slider = element;
    this.slidesContainer = this.slider.querySelector('.hero-banner__slides');
    this.slides = Array.from(this.slider.querySelectorAll('[data-slide]'));
    this.dots = Array.from(this.slider.querySelectorAll('[data-hero-dot]'));
    this.prevButton = this.slider.querySelector('[data-hero-prev]');
    this.nextButton = this.slider.querySelector('[data-hero-next]');
    this.currentSlide = 0;
    this.autoplayTimer = null;

    const banner = this.slider.closest('.hero-banner');
    this.autoplay = banner?.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(banner?.dataset.autoplaySpeed || '5000');

    this.#init();
  }

  #init() {
    this.#updateHeight(0);

    // atualiza altura ao redimensionar janela
    window.addEventListener('resize', () => this.#updateHeight(this.currentSlide));

    if (this.slides.length <= 1) return;

    this.#setupEventListeners();
    this.#showSlide(0);

    if (this.autoplay) {
      this.#startAutoplay();
    }
  }

  #updateHeight(index) {
    if (!this.slidesContainer || !this.slides[index]) return;
    const img = this.slides[index].querySelector('.hero-banner__image');
    if (img && img.complete && img.naturalHeight > 0) {
      const ratio = img.naturalHeight / img.naturalWidth;
      this.slidesContainer.style.height = (this.slidesContainer.offsetWidth * ratio) + 'px';
    } else if (img) {
      img.addEventListener('load', () => {
        const ratio = img.naturalHeight / img.naturalWidth;
        this.slidesContainer.style.height = (this.slidesContainer.offsetWidth * ratio) + 'px';
      }, { once: true });
    }
  }

  #setupEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.#prevSlide());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.#nextSlide());
    }

    for (const dot of this.dots) {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.heroDot);
        this.#goToSlide(index);
      });
    }

    this.slider.addEventListener('mouseenter', () => this.#stopAutoplay());
    this.slider.addEventListener('mouseleave', () => {
      if (this.autoplay) {
        this.#startAutoplay();
      }
    });

    let touchStartX = 0;
    let touchEndX = 0;

    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      this.#stopAutoplay();
    });

    this.slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.#handleSwipe(touchStartX, touchEndX);
      
      if (this.autoplay) {
        this.#startAutoplay();
      }
    });
  }

  #handleSwipe(startX, endX) {
    const diff = startX - endX;
    const threshold = 50;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.#nextSlide();
      } else {
        this.#prevSlide();
      }
    }
  }

  #showSlide(index) {
    for (const slide of this.slides) {
      slide.classList.remove('hero-banner__slide--active');
    }

    for (const dot of this.dots) {
      dot.classList.remove('hero-banner__dot--active');
    }

    this.slides[index].classList.add('hero-banner__slide--active');

    if (this.dots[index]) {
      this.dots[index].classList.add('hero-banner__dot--active');
    }

    this.currentSlide = index;
    this.#updateHeight(index);
  }

  #nextSlide() {
    const next = (this.currentSlide + 1) % this.slides.length;
    this.#goToSlide(next);
  }

  #prevSlide() {
    const prev = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.#goToSlide(prev);
  }

  #goToSlide(index) {
    this.#stopAutoplay();
    this.#showSlide(index);
    
    if (this.autoplay) {
      this.#startAutoplay();
    }
  }

  #startAutoplay() {
    this.#stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.#nextSlide();
    }, this.autoplaySpeed);
  }

  #stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-hero-slider]');
  
  for (const slider of sliders) {
    new HeroSlider(slider);
  }
});

if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector('[data-hero-slider]');
    if (slider) {
      new HeroSlider(slider);
    }
  });
}












